var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPush(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7134_99158",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7134_99158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.12371 15.9414H12.8804C12.7097 17.2443 11.4264 18.3205 10.0383 18.3325C8.61659 18.3451 7.32078 17.287 7.12305 15.9414H7.12371Z",
    fill: "#DEA829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8142 14.1892C17.7028 13.9158 17.4748 13.6751 17.2573 13.4637C16.1374 12.3776 15.5561 11.0607 15.5469 9.48977C15.5423 8.73365 15.5607 7.97753 15.5423 7.22208C15.4994 5.48047 14.814 4.04624 13.4878 2.93139C12.7107 2.27862 11.8064 1.90456 10.7986 1.72254L9.20755 1.71387C9.05991 1.74921 8.93402 1.78321 8.80747 1.80988C6.34964 2.32596 4.47513 4.64233 4.46129 7.18674C4.45734 7.9762 4.49886 8.76766 4.44679 9.55378C4.4079 10.1445 4.30442 10.7426 4.13767 11.3101C3.86216 12.2489 3.2683 12.9897 2.5558 13.6431C2.09772 14.0625 1.96919 14.5932 2.18472 15.188C2.37652 15.7174 2.88865 16.0775 3.4601 16.0782C7.82144 16.0808 12.1828 16.0828 16.5441 16.0768C17.5137 16.0755 18.182 15.0927 17.8136 14.1885L17.8142 14.1892Z",
    fill: "#DEA829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20898 1.71429L10.8001 1.72297C10.2458 1.6001 9.20898 1.71429 9.20898 1.71429Z",
    fill: "#DEA829"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPush);
export default __webpack_public_path__ + "static/media/push.348998c8127c6f22c94855485ee1c5ab.svg";
export { ForwardRef as ReactComponent };